<template>
  <div>
    <div
      v-if="operation && showOperationName"
      class="row"
    >
      <div class="col-12">
        {{ operation.name }}
      </div>
    </div>
    <div
      v-if="stateLicense"
      class="row"
    >
      <div class="col-12">
        <div class="row">
          <div class="col-12 overflow-hidden">
            <p class="text-nowrap mb-0">
              State License Number
            </p>
            <div class="clearfix mb--half" />
            <span class="text-sm text-light text-nowrap">
              {{ stateLicense }}
            </span>
            <a
              v-if="isDownloadable"
              :href="`/b-api/operations/state-license-doc/download/${stateLicenseDoc}`"
              :download="getFileName(stateLicenseDoc)"
              target="_blank"
            >
              <i class="bushel-icon bushel-download d-print-none" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="licenses && licenses.length">
      <div
        v-for="license in licenses"
        :key="license.id"
        class="row"
      >
        <div class="col-12">
          <p class="text-nowrap mb-0">
            {{ license.type }}
          </p>
          <div class="clearfix mb--half" />
          <span class="text-sm text-light text-nowrap">
            {{ license.number }}
          </span>
          <span v-if="license.documents && license.documents.length > 0">
            <div
              v-for="doc in license.documents"
              :key="doc.uuid"
              class="mb-1 d-inline-block"
            >
              <a
                v-if="isDownloadable"
                :href="downloadLink(doc)"
                :download="doc.name"
                target="_blank"
              >
                <i class="bushel-icon bushel-download d-print-none" />
              </a>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFileName } from "@/services/helpers";

export default {
  props: {
    licenses: { type: Array, required: false },
    isDownloadable: { type: Boolean, default: false },
    stateLicense: { type: String, required: false },
    stateLicenseDoc: { type: String, required: false },
    operation: { type: Object, required: false },
    showOperationName: { type: Boolean, default: false },
  },
  methods: {
    downloadLink(document) {
      const link = document.id ? `/b-api/docs/public-download/${document.uuid}` : document.file;
      return link;
    },
    getFileName,
  },
};
</script>
<style scoped lang="scss">
.bushel-download {
  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
}
</style>
